<template>
  <el-dialog
    title="优惠券数据"
    :visible.sync="visibile"
    :before-close="handleClose"
    :append-to-body="true"
    width="80%"
    @close="cancel"
  >
    <el-descriptions :column="4" size="small" border direction="vertical">
      <el-descriptions-item label="优惠券名称">{{ info.couponName }}</el-descriptions-item>
      <el-descriptions-item label="抵扣类型">{{ info.deductionType }}</el-descriptions-item>
      <el-descriptions-item label="抵扣金额">{{ info.discountAmount }}</el-descriptions-item>
      <el-descriptions-item label="所属供应商">{{ info.merchantName }}</el-descriptions-item>
      <el-descriptions-item label="总发行量"
        ><span class="tip__color">{{ info.totalNum }}</span></el-descriptions-item
      >
      <el-descriptions-item label="领取量"
        ><span class="tip__color">{{ info.receiveNum }}</span></el-descriptions-item
      >
      <el-descriptions-item label="领取率"
        ><span class="tip__color">{{ info.receiveRate }}</span></el-descriptions-item
      >
      <el-descriptions-item label="使用量"
        ><span class="tip__color">{{ info.validUseNum }}</span></el-descriptions-item
      >
      <el-descriptions-item label="优惠券金额"
        ><span class="tip__color">{{ info.discountAmount }}</span></el-descriptions-item
      >
      <el-descriptions-item label="支付金额"
        ><span class="tip__color">{{ info.payAmount }}</span></el-descriptions-item
      >
    </el-descriptions>

    <el-form :model="query" ref="query" :inline="true" size="small" style="padding-top: 20px">
      <el-form-item label="领取手机号">
        <el-input v-model="query.phoneNum" clearable />
      </el-form-item>
      <el-form-item label="券使用状态">
        <el-select clearable v-model="query.state" filterable placeholder="请选择">
          <el-option label="未使用" :value="1" />
          <el-option label="已使用" :value="2" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleQuery">查询</el-button>
      </el-form-item>
    </el-form>

    <el-table :data="data" size="mini" border max-height="300px">
      <el-table-column label="券码编号" align="center" prop="couponNo" />
      <el-table-column label="领取手机号" align="center" prop="phoneNum" />
      <el-table-column label="领取方式" align="center" prop="receiveType" />
      <el-table-column label="领取时间" align="center" prop="receiveTime" />
      <el-table-column label="生效时间" align="center" prop="validDate" />
      <el-table-column label="失效日期" align="center" prop="failureDate" />
      <el-table-column label="券使用状态" align="center" prop="state" />
      <el-table-column label="使用时间" align="center" prop="useTime" />
      <el-table-column label="业务类型" align="center" prop="bu" />
      <el-table-column label="使用订单号" align="center" prop="orderNo" />
    </el-table>
    <pagination
      :total="page.total"
      :page.sync="page.current"
      :limit.sync="page.size"
      @pagination="onLoad"
    />
    <div slot="footer" class="dialog-footer">
      <el-button size="small" type="danger" @click="cancel">取 消</el-button>
      <el-button type="primary" size="small" @click.stop="handleExcel">导出</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import { getCouponDetailsDataById, getCouponDetailsDataPage } from '@/api/marketing/coupon-api'
  import env from '@/config/env'
  export default {
    name: 'couponPkgView',
    components: {},
    data() {
      return {
        visibile: false,
        query: {
          phoneNum: '',
          state: null
        },
        data: [],
        info: {},
        page: {
          current: 1,
          size: 10,
          total: 0
        }
      }
    },
    methods: {
      init(id) {
        this.visibile = true
        this.getDetails(id)
      },
      async getDetails(id) {
        await getCouponDetailsDataById(id).then((resp) => {
          this.info = resp.data
          let receiveRate = this.info.receiveRate
          receiveRate = parseFloat(receiveRate.slice(0, receiveRate.length - 1)).toFixed(2)
          this.info.receiveRate = receiveRate + '%'
        })
        this.onLoad()
      },
      onLoad() {
        const adonData = {
          couponId: this.info.couponId,
          current: this.page.current,
          size: this.page.size,
          ...this.query
        }
        getCouponDetailsDataPage(adonData).then((resp) => {
          this.data = resp.data.records
          this.page.total = resp.data.total
        })
      },
      handleExcel() {
        this.$message({
          type: 'success',
          message: '文件下载中，请注意浏览器下载内容!'
        })
        window.location.href =
          env.importExcelUrl +
          env.ferryUrl +
          `/couponBatch/exportCouponData?couponId=${this.info.couponId}&phoneNum=${this.query.phoneNum}`
      },
      handleQuery() {
        this.page.current = 1
        this.onLoad()
      },
      cancel() {
        this.visibile = false
        this.query = {
          phoneNum: '',
          state: null
        }
      },
      handleClose(done) {
        this.visibile = false
        done()
      }
    }
  }
</script>

<style lang="scss" scoped>
  .tip__color {
    color: #1e9fff;
    font-size: 18px;
    font-weight: bold;
  }
</style>
